import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

export function AppIconCloseCircle({ size = 20, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  return (
    <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <Path
        fill={fill}
        d="M10 1.98633C14.4234 1.98641 18.0134 5.57661 18.0137 10C18.0137 14.4236 14.4236 18.0136 10 18.0137C5.57641 18.0136 1.98633 14.4236 1.98633 10C1.98656 5.57659 5.57655 1.98637 10 1.98633ZM10 3.78711C6.57066 3.78715 3.78734 6.57071 3.78711 10C3.78711 13.4295 6.57052 16.2138 10 16.2139C13.4295 16.2138 16.2139 13.4295 16.2139 10C16.2136 6.57073 13.4293 3.78719 10 3.78711ZM11.4844 7.24219C11.8358 6.89079 12.4063 6.89094 12.7578 7.24219C13.1093 7.59366 13.1093 8.16415 12.7578 8.51562L11.2734 10L12.7578 11.4854C13.1092 11.8368 13.1093 12.4073 12.7578 12.7588C12.4063 13.11 11.8358 13.1101 11.4844 12.7588L10 11.2734L8.51562 12.7588C8.16424 13.1101 7.59367 13.11 7.24219 12.7588C6.89073 12.4073 6.89075 11.8368 7.24219 11.4854L8.72656 10L7.24219 8.51562C6.89072 8.16415 6.89072 7.59366 7.24219 7.24219C7.59368 6.89094 8.16423 6.89079 8.51562 7.24219L10 8.72754L11.4844 7.24219Z"
      />
    </Svg>
  )
}
